export default __webpack_public_path__ + "static/media/portfolio1.f70ecb09.jpg";